var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseIcon',_vm._b({scopedSlots:_vm._u([{key:"svg",fn:function(){return [_c('SvgIcon',{staticClass:"mail"})]},proxy:true}])},'BaseIcon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }